import React from 'react';

import './PageSettingsEditor.scss';
import Fieldset from 'RLX/Forms/Fieldset';
import { updatePage } from 'RLX/State/Content/ContentActions';
import { stripLeadingSlash } from 'Core/Utils';

class PageSettingsEditor extends React.Component {
  constructor (props) {
    super(props);
    this.propertyUpdateFactory = this.propertyUpdateFactory.bind(this);
  }

  propertyUpdateFactory (property, transformValue) {
    const existing = this.props.page;
    const handler = function (newValue) {
      if (typeof transformValue === 'function') newValue = transformValue(newValue);
      const page = { ...existing, [property]: newValue };
      updatePage(page);
    };
    return handler.bind(this);
  }

  render () {
    const { propertyUpdateFactory } = this;
    const { page } = this.props;
    const { name, url, shy, content, blog, external, hidden } = page;

    const settingsFields = [
      {
        label: 'Page Name',
        value: name,
        icon: 'hashtag',
        required: true,
        onChange: propertyUpdateFactory('name'),
        type: 'text',
        className: 'half'
      },
      {
        label: external ? 'Link to URL' : 'URL Slug',
        value: external ? url : '/' + url,
        icon: external ? 'link' : 'anchor',
        validate: external ? 'url' : 'urlSlug',
        required: true,
        onChange: propertyUpdateFactory('url', external ? null : stripLeadingSlash),
        className: 'half',
        type: 'text'
      },
      {
        label: 'External Link',
        value: external,
        icon: 'globe',
        type: 'toggle',
        onChange: propertyUpdateFactory('external'),
        className: 'third'
      },
      {
        label: 'Hidden',
        value: hidden,
        icon: 'low-vision',
        type: 'toggle',
        onChange: propertyUpdateFactory('hidden'),
        className: 'third'
      },
      {
        label: 'Hide On Top Nav',
        value: shy,
        icon: 'compass',
        type: 'toggle',
        onChange: propertyUpdateFactory('shy'),
        className: 'third'
      }
    ];

    return (
      <div className="PageSettingsEditor">
        <Fieldset fields={settingsFields} />
      </div>
    );
  }
};

export default PageSettingsEditor;



// WEBPACK FOOTER //
// ./client/RLX/Views/Dashboard/Panes/PageEditor/PageSettings/PageSettingsEditor.jsx